module.exports = __webpack_public_path__ + "ma.68c6eafb.svg";